
        var result = require("!!../../../../node_modules/css-loader/index.js!./appointmentlabel.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-planner/appointmentlabel.component.css
// module id = 2442
// module chunks = 1